<p class="no-results-info" data-hook="no-matching-results-text">
  {{ message }}
</p>
